export const qbrickThumbnailImage = (resources: any, thumbnails: any) => {
  const images = resources.filter((item: any) => {
    return item.type === 'image';
  });

  const thumbnailId = thumbnails && thumbnails[0].id;
  const thumbnailImage = images.filter((item: any) => item.id === thumbnailId);
  return thumbnailImage[0].renditions[0].links[0].href;
};
